import React, { useState } from "react";
import { toast } from "react-toastify";
import { Input, Select } from "../../../components/form";
import { Button } from "../../../components/button";
import { ScanAction } from "../../../__generated__/globalTypes";
import { useScanStockUnit } from "../hooks";
import { scanActionLabel } from "../../../helpers/enum-labels";

export const ScanStockUnitForm: React.FC = () => {
  const [qrCode, setQrCode] = useState("");
  const [action, setAction] = useState<ScanAction | "">("");
  const { scan, loading, data } = useScanStockUnit();

  const handleSubmit = async () => {
    if (!qrCode.trim() || !action) return;
    const stockUnit = await scan({ input: { qrCode: qrCode.trim(), action } });
    if (stockUnit) {
      toast.success("Scan enregistré");
      setQrCode("");
    }
  };

  return (
    <div className="w-full">
      <div className="flex flex-wrap gap-3 items-end">
        <Input
          label="Code QR"
          className="w-full"
          value={qrCode}
          onChange={(e) => setQrCode(e.target.value)}
          placeholder="Coller ou saisir le code scanné"
        />
        <Select
          label="Action"
          className="w-full"
          value={action}
          onChange={(e) => setAction(e.target.value as ScanAction)}
        >
          <option value="">-</option>
          {Object.keys(ScanAction).map((a) => (
            <option key={a} value={a}>
              {scanActionLabel(a)}
            </option>
          ))}
        </Select>
        <Button onClick={handleSubmit} loading={loading} disabled={loading || !qrCode || !action}>
          Enregistrer le scan
        </Button>
      </div>

      {data?.scanStockUnit?.stockUnit && (
        <div className="mt-4 p-3 bg-gray-50 rounded">
          <p className="text-sm font-medium">
            {data.scanStockUnit.stockUnit.product?.name} — Lot{" "}
            {data.scanStockUnit.stockUnit.batchNumber}
          </p>
          <p className="text-xs text-gray-500">
            Entrepôt : {data.scanStockUnit.stockUnit.warehouse?.name}
          </p>
        </div>
      )}
    </div>
  );
};
